module.exports = __webpack_public_path__ + "img/two_ad.a112c371.jpg";